import api from "Common/Client/Interceptor";

export const fetchProjectData = async (id, userId, token) => {
  try {
    const response = await api.get(
      `/Training/Learner/Get-Detail?trainingId=${id}&learnerId=${userId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching project data:", error);
    throw error;
  }
};

export const fetchCategories = async (token) => {
  try {
    const response = await api.get("/TrainingIsuue/Categories/List", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to load categories", error);
    throw error;
  }
};

export const submitIssueReport = async (requestData) => {
  try {
    const response = await api.post("/TrainingIsuue/Create-Issue", requestData);
    return response.data;
  } catch (error) {
    console.error("Error submitting issue:", error);
    throw error;
  }
};

export const fetchViewHistory = async (memberId, token) => {
  try {
    const response = await api.get(`/TrainingIsuue/Learner/List?memberId=${memberId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "*/*",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch view history", error);
    throw error;
  }
};
